'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { FILTER_TYPE } from '../Filters.types';
import FilterDropdowns from './FilterDropdowns';
import FiltersSheet from './FiltersSheet';
export interface UpdateFiltersProps {
  type: FILTER_TYPE;
  value: string;
  maxOptionsCount: number;
}
interface Props {
  handleRouteChange: (newRoute: string) => void;
}
const AdditionalFilters = t0 => {
  const $ = _c(34);
  const {
    handleRouteChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      [FILTER_TYPE.LEVEL]: t1,
      [FILTER_TYPE.LOCATION_OFFERING]: []
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [selectedFilters, setSelectedFilters] = useState(t2);
  const searchParams = useSearchParams();
  let t3;
  if ($[2] !== searchParams) {
    t3 = new URLSearchParams(searchParams.toString());
    $[2] = searchParams;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const params = t3;
  let t4;
  if ($[4] !== handleRouteChange || $[5] !== params || $[6] !== selectedFilters) {
    t4 = () => {
      Object.keys(selectedFilters).forEach(type => {
        params.delete(type);
        const filterValues = selectedFilters[type as FILTER_TYPE];
        filterValues.forEach(filterValue => params.append(type, filterValue));
      });
      handleRouteChange(`${window.location.pathname}?${params.toString()}`);
    };
    $[4] = handleRouteChange;
    $[5] = params;
    $[6] = selectedFilters;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleApply = t4;
  let t5;
  if ($[8] !== selectedFilters) {
    t5 = t6 => {
      const {
        type: type_0,
        value,
        maxOptionsCount
      } = t6;
      return () => {
        const currentSelections = selectedFilters[type_0];
        const isSelected = currentSelections.includes(value);
        const newFilters = isSelected ? currentSelections.filter(option => option !== value) : [...currentSelections, value];
        if (newFilters.length === maxOptionsCount) {
          setSelectedFilters(prev => ({
            ...prev,
            [type_0]: []
          }));
        } else {
          setSelectedFilters(prev_0 => ({
            ...prev_0,
            [type_0]: newFilters
          }));
        }
      };
    };
    $[8] = selectedFilters;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const updateFilters = t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = type_1 => () => {
      setSelectedFilters(prev_1 => ({
        ...prev_1,
        [type_1]: []
      }));
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const resetFilter = t6;
  let t7;
  if ($[11] !== handleRouteChange || $[12] !== params) {
    t7 = () => {
      Object.values(FILTER_TYPE).forEach(filterType => {
        params.delete(filterType);
      });
      handleRouteChange(`${window.location.pathname}?${params.toString()}`);
    };
    $[11] = handleRouteChange;
    $[12] = params;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const resetAllFilters = t7;
  let t8;
  if ($[14] !== searchParams) {
    t8 = () => {
      setSelectedFilters({
        [FILTER_TYPE.LEVEL]: searchParams.getAll(FILTER_TYPE.LEVEL),
        [FILTER_TYPE.LOCATION_OFFERING]: searchParams.getAll(FILTER_TYPE.LOCATION_OFFERING)
      });
    };
    $[14] = searchParams;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const setInitialFilterSelection = t8;
  let t9;
  if ($[16] !== setInitialFilterSelection) {
    t9 = () => {
      setInitialFilterSelection();
    };
    $[16] = setInitialFilterSelection;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== searchParams) {
    t10 = [searchParams];
    $[18] = searchParams;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  useEffect(t9, t10);
  let t11;
  if ($[20] !== handleApply || $[21] !== resetAllFilters || $[22] !== selectedFilters || $[23] !== setInitialFilterSelection || $[24] !== updateFilters) {
    t11 = <FiltersSheet selectedFilters={selectedFilters} updateFilters={updateFilters} resetFilter={resetFilter} resetAllFilters={resetAllFilters} handleApply={handleApply} undoFilterSelection={setInitialFilterSelection} />;
    $[20] = handleApply;
    $[21] = resetAllFilters;
    $[22] = selectedFilters;
    $[23] = setInitialFilterSelection;
    $[24] = updateFilters;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== handleApply || $[27] !== selectedFilters || $[28] !== setInitialFilterSelection || $[29] !== updateFilters) {
    t12 = <FilterDropdowns selectedFilters={selectedFilters} updateFilters={updateFilters} resetFilter={resetFilter} handleApply={handleApply} undoFilterSelection={setInitialFilterSelection} />;
    $[26] = handleApply;
    $[27] = selectedFilters;
    $[28] = setInitialFilterSelection;
    $[29] = updateFilters;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t11 || $[32] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
export default AdditionalFilters;